<template>
  <BaseDialogNoPadding ref="popup">
    <div class="content-ct">
      <div class="toolbar-header">
        <span>{{ product_name }} - Overview </span>
        <i class="action material-icons close-icon" @click="_cancel()">close</i>
      </div>
      <img v-if="file_name !== ''" :src="`/api/fs/public-products/overview/${file_name}#toolbar=0`" />
    </div>
  </BaseDialogNoPadding>
</template>

<script>
import BaseDialogNoPadding from '../BaseDialogNoPadding.vue'

export default {
  name: 'PublicProductOverview',

  components: { BaseDialogNoPadding },

  data: () => ({
    file_name: '',
    product_name: '',
    okButton: 'Submit', // Text for confirm button; leave it empty because we don't know what we're using it for
    cancelButton: 'Cancel', // text for cancel button
    // Private variables
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),

  methods: {
    show(opts = {}) {
      this.file_name = ''
      if (opts.file_name) {
        this.file_name = opts.file_name
      }
      this.product_name = ''
      if (opts.product_name) {
        this.product_name = opts.product_name
      }
      // Once we set our config, we tell the popup modal to open
      this.$refs.popup.open()
      // Return promise so the caller can get results
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    _confirm() {
      this.$refs.popup.close()
      this.resolvePromise(true)
    },

    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise(false)
      // Or you can throw an error
      // this.rejectPromise(new Error('User cancelled the dialogue'))
    },
  },
}
</script>

<style scoped>
.toolbar-header {
  background: #414141;
  color: #fff;
  padding: 12px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.floating-close {
  position: absolute;
  cursor: pointer;
  top: 15px;
  right: 40px;
}
.close-icon {
  cursor: pointer;
  color: white;
  position: absolute;
  right: 12px;
}
.body-msg {
  padding: 0 12px;
  display: grid;
}
.news-ct {
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: 35px;
}
.news-header {
  display: flex;
  width: 100%;
  flex-direction: row;
  padding-bottom: 5px;
  margin-bottom: 12px;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #0a4bb7;
}
.news-header .title {
  font-weight: 500;
}
.news-header .date {
  font-weight: 500;
  font-size: 14px;
  color: #b1b1b1;
}
h2 {
  color: #b1b1b1;
}
.btns {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.label-class {
  display: block;
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.action-btn {
  padding: 0.5em 1em;
  border-radius: 5px;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  cursor: pointer;
}
.confirm {
  background-color: #282f54;
  color: #fff !important;
}
.content-ct {
  width: 1280px;
  height: 775px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  position: relative;
}
</style>
